module.exports = __webpack_public_path__ + "static/media/chat-moderation-bubble.96ed6f2d.svg";